module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10181.c297014c.jpg";